import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import VM from 'scratch-vm';

import backdropLibraryContent from '../lib/libraries/backdrops.json';
import backdropTags from '../lib/libraries/backdrop-tags';
import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Backdrop',
        description: 'Heading for the backdrop library',
        id: 'gui.costumeLibrary.chooseABackdrop'
    }
});

class BackdropLibrary extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    async handleItemSelect (item) {
        const storage = this.props.vm.runtime.storage;

        // Load locally stored backdrop into Scratch Storage
        if (item.rawURL) {
            const response = await fetch(item.rawURL);

            if (!response.ok) {
                throw new Error(`Could not load backdrop: ${item.rawURL}`);
            }

            const data = new Uint8Array(await response.arrayBuffer());
            const extension = item.dataFormat ||
                item.md5ext.split('.').pop().toLowerCase();

            const assetId = item.assetId ||
                item.md5ext.split('.')[0];

            let assetType;
            let dataFormat;

            if (extension === 'svg') {
                assetType = storage.AssetType.ImageVector;
                dataFormat = storage.DataFormat.SVG;
            } else if (extension === 'jpg' || extension === 'jpeg') {
                assetType = storage.AssetType.ImageBitmap;
                dataFormat = storage.DataFormat.JPG;
            } else {
                assetType = storage.AssetType.ImageBitmap;
                dataFormat = storage.DataFormat.PNG;
            }

            storage.builtinHelper._store(
                assetType,
                dataFormat,
                data,
                assetId
            );
        }

        const vmBackdrop = {
            name: item.name,
            rotationCenterX: item.rotationCenterX,
            rotationCenterY: item.rotationCenterY,
            bitmapResolution: item.bitmapResolution,
            skinId: null
        };

        // Add the backdrop without switching to the stage
        await this.props.vm.addBackdrop(item.md5ext, vmBackdrop);
    }

    render () {
        return (
            <LibraryComponent
                data={backdropLibraryContent}
                id="backdropLibrary"
                tags={backdropTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

BackdropLibrary.propTypes = {
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(BackdropLibrary);